import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import useTable from "../components/useTable"
import { Dimmer } from '../components/spinner';
import axios from "axios";
import moment from 'moment';

const CatalogoIncorpBien = props => {

    let op = require('../modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const btnBuscar = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [activo, setActivo] = useState(true);
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);

    const headCells = [
        { id: 'cedula', label: 'CÓDIGO', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'fechaincorporacion', label: 'FECHA', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'apellidos', label: 'CÓDIGO', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idincorporacionmueble.includes(target.value)
                            || moment(x.fechaincorporacion).format('DD-MM-YYYY').toLowerCase().includes(target.value.toLowerCase())
                            || x.codigobien.toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {
        let campos = "*"
        let nomtab = "incorporacionmueble";
        let condi = 'idincorporacionmueble > 0';
        let orden = "idincorporacionmueble";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setRecords(response.data);
            }
            setActivate(false);
        }).catch(function (error) {
            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);
        })
    }

    const seleccionarLista = (index) => (event) => {
        blanquear();
        props.onHideAceptaCatalogo(values);
    };

    const blanquear = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }

    const handleCloseMensa = () => {
        setMostrar(false);
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    }

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        var incorporacionbien = recordsAfterPagingAndSorting()[index].idincorporacionmueble;
        setValues(incorporacionbien);
    };

    return (
        <Modal
            {...props}
            size="lg"
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.521)'
            }}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarRegistros();
                btnBuscar.current.focus();
            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar ubicación.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} ref={btnBuscar} className="form-control rounded-pill search-input text-uppercase" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idincorporacionmueble} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "10px", verticalAlign: "middle" }}>{item.idincorporacionmueble}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "100px", verticalAlign: "middle" }}>{moment(item.fechaincorporacion).format('DD-MM-YYYY')}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "100px", verticalAlign: "middle" }}>{item.codigobien}</td>
                                    </tr>
                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoIncorpBien;